<div class="vm-monitoring-filter" #dropdownRoot>
    <button
            type="button"
            class="vm-monitoring-trigger"
            [class.vm-monitoring-trigger-open]="isOpen"
            [attr.aria-expanded]="isOpen"
            aria-haspopup="listbox"
            (click)="toggleOpen($event)"
            (keydown)="onTriggerKeydown($event)">
        <span class="vm-monitoring-label">{{ collapsedLabel }}</span>
        <span class="vm-monitoring-caret" [class.vm-monitoring-caret-open]="isOpen" aria-hidden="true">&#9662;</span>
    </button>

    <div
            *ngIf="isOpen"
            class="vm-monitoring-dropdown"
            role="listbox"
            aria-multiselectable="true"
            (click)="$event.stopPropagation()">
        <label
                *ngFor="let option of options; let index = index"
                class="vm-monitoring-option"
                [attr.for]="'vm-monitoring-option-' + index">
            <input
                    type="checkbox"
                    class="vm-monitoring-checkbox"
                    [id]="'vm-monitoring-option-' + index"
                    [checked]="isSelected(option.value)"
                    (change)="toggleOption(option.value, $event)"
                    (keydown)="onOptionKeydown($event)">
            <span class="vm-monitoring-label">{{ option.label }}</span>
        </label>
    </div>
</div>
